import { useEffect as u } from "react";
var m = ({ ref: e, onClickOutside: t, enabled: r = !0 }) => {
  u(() => {
    if (!r) return;
    const n = (o) => {
      e.current?.contains(o.target) || t();
    };
    return document.addEventListener("mousedown", n), () => document.removeEventListener("mousedown", n);
  }, [
    e,
    t,
    r
  ]);
};
export {
  m as useClickOutside
};

//# sourceMappingURL=useClickOutside.js.map